import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { FormPackage } from '../models/df-package';
import { Observable, Subscription } from 'rxjs';

@Injectable()
export class DynamicFormPackageControlService {
	formSubscription: Subscription;
	constructor(private fb: FormBuilder) {}

	isObject(obj: any) {
		return obj === Object(obj);
	}

	toFormGroup(formPackages: FormPackage[], componentData: any) {
		let group: any = {};
		let jsonConfig: Object = componentData.config;

		group = {
			type: componentData.config.type || 24,
			desc: componentData.config.desc || 'Custom',
			id: componentData.config.id || 'custom',
			text: ''
		};

		formPackages.forEach((formPackage) => {
			switch (formPackage.type) {
				case 'fontBox': {
					group[formPackage.key] = this.fb.group({
						font: [(jsonConfig[formPackage.key] && jsonConfig[formPackage.key].font) || formPackage.defaultValue.font || ''],

						size: [
							(jsonConfig[formPackage.key] && jsonConfig[formPackage.key].size) || formPackage.defaultValue.size,
							[Validators.required, Validators.min(6), Validators.max(48)]
						],
						custom: (jsonConfig[formPackage.key] && jsonConfig[formPackage.key].custom) || formPackage.defaultValue.custom || ''
					});
					break;
				}

				case 'datePicker': {
					const groupOptions = {
						// eslint-disable-next-line max-len, prettier/prettier
				    timestamp: !!formPackage.required ? [(jsonConfig[formPackage.key] && jsonConfig[formPackage.key].timestamp) || formPackage.defaultValue.timestamp || new Date().getDate(), Validators.required] : (jsonConfig[formPackage.key] && jsonConfig[formPackage.key].timestamp) || formPackage.defaultValue.timestamp || new Date().getDate(),
						// eslint-disable-next-line max-len, prettier/prettier
						time: !!formPackage.required ? [(jsonConfig[formPackage.key] && jsonConfig[formPackage.key].time) || formPackage.defaultValue.time || new Date(), Validators.required] : (jsonConfig[formPackage.key] && jsonConfig[formPackage.key].time) || formPackage.defaultValue.time || new Date(),
						// eslint-disable-next-line max-len, prettier/prettier
						dateTime: !!formPackage.required ? [(jsonConfig[formPackage.key] && jsonConfig[formPackage.key].time) || formPackage.defaultValue.time || new Date(), Validators.required] : (jsonConfig[formPackage.key] && jsonConfig[formPackage.key].time) || formPackage.defaultValue.time || new Date()
					};
					group[formPackage.key] = this.fb.group(groupOptions);
					break;
				}

				case 'fileBox': {
					if (Array.isArray(jsonConfig[formPackage.key])) {
						group[formPackage.key] = this.fb.array(jsonConfig[formPackage.key]);
					} else {
						group[formPackage.key] = this.fb.array([jsonConfig[formPackage.key]]);
					}
					break;
				}

				default: {
					group[formPackage.key] = !!formPackage.required
						? [jsonConfig[formPackage.key] || formPackage.defaultValue || '', Validators.required]
						: jsonConfig[formPackage.key] || formPackage.defaultValue || '';
					break;
				}
			}
		});

		return this.fb.group(group);
	}
}
